module.exports = __webpack_public_path__ + "media/images/user-icon-white-311a588a9bef7761d771b7b587238c55.svg";